export default __webpack_public_path__ + "static/media/Leatherface.210144e7.mp3";